import { combineReducers } from "redux";
import ui from "./reducers/UiReducer";
import data from './reducers/DataReducer';

const rootReducer = combineReducers({
  ui, data
});

export default rootReducer;
